module.exports = __webpack_public_path__ + "static/media/app-bar-logo.7891ec03.svg";